// @flow
import type {Action} from '../../../state/types'

export type SetPaginationPayload = {
  pagination: PaginationResponse<PartnerPlace>,
}

const id = 'place/SET_PAGINATION'

export const setPagination = (pagination: PaginationResponse<PartnerPlace>): Action<SetPaginationPayload> => ({
  type: id,
  payload: {
    pagination
  }
})

setPagination.id = id
